// import ReactImageGallery from 'react-image-gallery';
// import { Carousel } from 'react-responsive-carousel';
// import Carousel from '@brainhubeu/react-carousel';
import { CancelButton, EditButton } from '@core/components/Buttons';
import Carousel from '@core/components/Carousel';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { TextLabel } from '@core/components/Inputs';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { DataBR } from '@format/DATA';
import { Divider, Grid, Tooltip, Typography } from '@material-ui/core';
import { formataQuantidade } from 'app/utils/mask';
import { calcularValorComDesconto } from 'app/utils/monetarioUtil';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { ProdutoContext } from '../../../ProdutoContext';
import { produtoModais } from '../produtoModais';
import { produtoModalStyles } from './styles';

const getCurrency = (value) => {
  if (value === null || value === undefined) {
    return undefined;
  }

  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');
};

const formatNumber = (value) => {
  if (typeof value === 'number') {
    return `${value}`.replace('.', ',');
  }
  return '';
};

const finalidades = {
  VAZIO: ' ',
  MERCADORIA_REVENDA: '00 - Mercadoria para Revenda',
  MATERIA_PRIMA: '01 - Matéria-prima',
  EMBALAGEM: '02 - Embalagem',
  PRODUTO_EM_PROCESSO: '03 - Produto em Processo (produto semi-acabado)',
  PRODUTO_ACABADO: '04 - Produto Acabado',
  SUBPRODUTO: '05 - Subproduto',
  PRODUTO_INTERMEDIARIO: '06 - Produto Intermediário',
  MATERIAL_USO_CONSUMO: '07 - Material de Uso e Consumo',
  ATIVO_IMOBILIZADO: '08 - Ativo Imobilizado',
  SERVICOS: '09 - Serviços',
  OUTROS_INSUMOS: '10 - Outros insumos',
  OUTRAS: '99 - Outras',
};

const tipoUnidadeMedida = {
  QUILOGRAMA: 'Quilograma',
  UNIDADE: 'Unidade',
};

const VisualizarProdutoModal = () => {
  const [modal, setModal] = useContext(ProdutoContext).modal;
  const [produto] = useContext(ProdutoContext).produtoAtual;

  const modalStyles = produtoModalStyles();

  // FA-08 Fechar
  const handleCloseModal = () => {
    setModal(false);
  };

  const handleDescontoCaractere = () => {
    const tipoDesconto = produto?.promocao?.tipoDesconto;
    const desconto = produto?.promocao?.desconto;
    return tipoDesconto === 'PERCENTUAL' ? `${formatNumber(desconto)}%` : `R$${getCurrency(desconto)}`;
  };

  const handleOpenEditMode = () => {
    setModal(produtoModais.cadastroProduto);
  };

  const valorComDesconto = calcularValorComDesconto(
    produto?.promocao?.tipoDesconto,
    produto?.valorUnitario,
    produto?.promocao?.desconto
  );

  let periodoPromocao = '';

  if (produto?.promocao?.vigenciaInicio && produto?.promocao?.vigenciaFim) {
    periodoPromocao = `${moment(produto?.promocao?.vigenciaInicio).format('DD/MM/YYYY')} a ${moment(
      produto?.promocao?.vigenciaFim
    ).format('DD/MM/YYYY')}`;
  }

  const emPromocao =
    produto.promocao &&
    moment()
      .startOf('day')
      .isBetween(produto.promocao.vigenciaInicio, produto.promocao.vigenciaFim, undefined, '[]');

  const DadosProduto = () => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="nome" label="Nome do produto" value={produto?.nome} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="codigo" label="Código do produto (SKU)" value={produto?.codigo} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="descricaoDetalhada"
            label="Descrição detalhada do produto"
            value={(produto?.descricaoDetalhada || '').split('\n')}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="tipoFinalidade"
            label="Finalidade (Bloco K)"
            value={finalidades[produto?.tipoFinalidade] || ''}
          />
        </Grid>
        <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
          <TextLabel
            id="valorUnitario"
            label="Valor unitário da venda (R$)"
            value={getCurrency(produto?.valorUnitario)}
          />
        </Grid>
        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <TextLabel id="custoMedio" label="Custo médio (R$)" value={getCurrency(produto?.custoMedio)} />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextLabel id="dataValidade" label="Data de validade" value={DataBR(produto?.dataValidade)} />
        </Grid>
        <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
          <TextLabel id="estoqueMinimo" label="Estoque mínimo" value={formataQuantidade(produto?.estoqueMinimo)} />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextLabel id="estoqueMaximo" label="Estoque máximo" value={formataQuantidade(produto?.estoqueMaximo)} />
        </Grid>
        <Grid item xs={4} sm={4} md={5} lg={5} xl={5}>
          <TextLabel
            id="quantidadeEstoque"
            label="Quantidade em estoque"
            value={formataQuantidade(produto?.quantidadeEstoque)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="codigoBarras" label="Código de barras (EAN)" value={produto?.codigoBarras} />
        </Grid>
        {emPromocao && (
          <Grid item container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h6">Produto em promoção</Typography>
              <Divider />
            </Grid>
            <hr />
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel id="vigencia" label="Período de vigência" value={periodoPromocao} />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id="desconto"
                label={`Desconto ${produto?.promocao?.tipoDesconto === 'VALOR' ? '(R$)' : '(%)'}`}
                value={handleDescontoCaractere()}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel id="valorComDesconto" label="Valor com desconto (R$)" value={getCurrency(valorComDesconto)} />
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  };

  const DadosFiscais = () => {
    const ncm = produto?.fiscal?.codigoNCM?.descricao;
    const cest = produto?.fiscal?.cest?.descricao
      ? `${produto?.fiscal?.cest?.codigo} - ${produto?.fiscal?.cest?.descricao}`
      : ' - ';
    const cfop = produto?.fiscal?.cfop?.descricao
      ? `${produto?.fiscal?.cfop?.codigo} - ${produto?.fiscal?.cfop?.descricao}`
      : ' - ';
    const origemProduto = produto?.fiscal?.origemProduto?.descricao
      ? `${produto?.fiscal?.origemProduto?.valor} - ${produto?.fiscal?.origemProduto?.descricao}`
      : ' - ';
    const codigoTributarioIcms = produto?.fiscal?.icms?.situacaoTributaria
      ? produto?.fiscal?.icms?.situacaoTributaria?.codigo
      : null;
    const codigoTributarioIpi = produto?.fiscal?.ipi?.situacaoTributaria
      ? produto?.fiscal?.ipi?.situacaoTributaria?.codigo
      : null;

    const reformaTributaria = produto?.fiscal?.cstSituacaoTributaria
      ? produto?.fiscal?.cstSituacaoTributaria?.id
      : produto?.fiscal?.cstClassificacaoTributaria
      ? produto?.fiscal?.cstClassificacaoTributaria?.id
      : null;

    return (
      <div className={modalStyles.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="ncm" label="Código NCM" value={ncm} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="cest" label="CEST" value={cest} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="cfop" label="CFOP" value={cfop} />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="unidadeMedida"
              label="Unidade de medida"
              value={tipoUnidadeMedida[produto?.fiscal?.tipoUnidadeMedida] || ''}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="pesoLiquido" label="Peso líquido (kg)" value={formatNumber(produto?.fiscal?.pesoLiquido)} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="pesoBruto" label="Peso bruto (kg)" value={formatNumber(produto?.fiscal?.pesoBruto)} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="altura" label="Altura (cm)" value={formatNumber(produto?.fiscal?.altura)} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="largura" label="Largura (cm)" value={formatNumber(produto?.fiscal?.largura)} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="profundidade"
              label="Profundidade (cm)"
              value={formatNumber(produto?.fiscal?.profundidade)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="origemProduto" label="Origem do produto" value={origemProduto} />
          </Grid>

          {codigoTributarioIcms !== null && DadosFiscaisIcms(codigoTributarioIcms)}
          {codigoTributarioIpi !== null && DadosFiscaisIpi(codigoTributarioIpi)}
          {reformaTributaria && DadosFiscaisReformaTributaria(produto?.fiscal)}
        </Grid>
      </div>
    );
  };

  const getSituacaoTributaria = () => {
    const situacaoTributaria = produto?.fiscal?.icms?.situacaoTributaria
      ? `${produto?.fiscal?.icms?.situacaoTributaria?.codigo} - ${produto?.fiscal?.icms?.situacaoTributaria?.descricao}`
      : ' - ';

    return situacaoTributaria;
  };

  const getMotivoDesoneracao = () => {
    const motivoDesoneracao =
      produto?.fiscal?.icms?.motivoDesoneracao?.codigo !== undefined
        ? `${produto?.fiscal?.icms?.motivoDesoneracao?.codigo} - ${produto?.fiscal?.icms?.motivoDesoneracao?.descricao}`
        : ' - ';
    return motivoDesoneracao;
  };

  const getUfIcmsStDevido = () => {
    const ufIcmsStDevido =
      produto?.fiscal?.icms?.ufIcmsStDevido.id !== undefined ? `${produto?.fiscal?.icms?.ufIcmsStDevido?.nome}` : ' - ';
    return ufIcmsStDevido;
  };

  const getModalidadeDeterminacaoBc = () => {
    var modalidadeDeterminacaoBC;

    if (produto?.fiscal?.icms?.modalidadeDeterminacaoBC === 'MARGEM_VALOR_AGREGADO') {
      modalidadeDeterminacaoBC = '0 - Margem Valor Agregado (%)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBC === 'PAUTA') {
      modalidadeDeterminacaoBC = '1 - Pauta (Valor)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBC === 'PRECO_TABELADO_MAX') {
      modalidadeDeterminacaoBC = '2 - Preço Tabelado Máx. (valor)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBC === 'VALOR_OPERACAO') {
      modalidadeDeterminacaoBC = '3 - Valor da operação';
    } else {
      modalidadeDeterminacaoBC = '-';
    }

    return modalidadeDeterminacaoBC;
  };

  const getModalidadeDeterminacaoBcIcmsSt = () => {
    var modalidadeDeterminacaoBcIcmsST;

    if (produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST === 'PRECO_TABELADO_MAX') {
      modalidadeDeterminacaoBcIcmsST = '0 - Preço tabelado ou máximo sugerido';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST === 'LISTA_NEGATIVA') {
      modalidadeDeterminacaoBcIcmsST = '1 - Lista Negativa (valor)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST === 'LISTA_POSITIVA') {
      modalidadeDeterminacaoBcIcmsST = '2 - Lista Positiva (valor)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST === 'LISTA_NEUTRA') {
      modalidadeDeterminacaoBcIcmsST = '3 - Lista Neutra (valor)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST === 'MARGEM_VALOR_AGREGADO') {
      modalidadeDeterminacaoBcIcmsST = '4 - Margem Valor Agregado (%)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST === 'PAUTA') {
      modalidadeDeterminacaoBcIcmsST = '5 - Pauta (valor)';
    } else if (produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST === 'VALOR_OPERACAO') {
      modalidadeDeterminacaoBcIcmsST = '6 - Valor da Operação';
    } else {
      modalidadeDeterminacaoBcIcmsST = '-';
    }

    return modalidadeDeterminacaoBcIcmsST;
  };

  const DadosFiscaisIcms = (codigoTributario) => {
    return (
      <>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="h6">ICMS</Typography>
          <Divider style={{ height: '2px', background: 'silver' }} />
        </Grid>

        {codigoTributario === '00' && visualizarICMS00()}

        {codigoTributario === '10' && visualizarICMS10()}

        {codigoTributario === '20' && visualizarICMS20()}

        {codigoTributario === '30' && visualizarICMS30()}

        {(codigoTributario === '40' || codigoTributario === '41' || codigoTributario === '50') &&
          visualizarICMS40_41_50()}

        {codigoTributario === '51' && visualizarICMS51()}

        {codigoTributario === '60' && visualizarICMS60()}

        {(codigoTributario === '70' || codigoTributario === '90') && visualizarICMS70_90()}
        {codigoTributario === '101' && visualizarICMS101()}

        {(codigoTributario === '102' ||
          codigoTributario === '103' ||
          codigoTributario === '300' ||
          codigoTributario === '400') &&
          visualizarICMS102_103_300_400()}

        {codigoTributario === '201' && visualizarICMS201()}

        {(codigoTributario === '202' || codigoTributario === '203') && visualizarICMS202_203()}

        {codigoTributario === '500' && visualizarICMS500()}

        {codigoTributario === '900' && visualizarICMS900()}
      </>
    );
  };

  const DadosFiscaisIpi = (codigoTributario) => {
    var valorBcIpi = null;

    const situacaoTributaria = produto?.fiscal?.ipi?.situacaoTributaria
      ? `${produto?.fiscal?.ipi?.situacaoTributaria?.codigo} - ${produto?.fiscal?.ipi?.situacaoTributaria?.descricao}`
      : ' - ';

    if (
      produto?.fiscal?.ipi?.valorBc !== undefined &&
      produto?.fiscal?.ipi?.valorBc !== null &&
      produto?.fiscal?.ipi?.valorBc !== 0
    ) {
      valorBcIpi = getCurrency(produto?.fiscal?.ipi?.valorBc).trim();
    }

    return (
      <>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="h6">IPI</Typography>
          <Divider style={{ height: '2px', background: 'silver' }} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={situacaoTributaria} />
        </Grid>

        {(codigoTributario === '50' ||
          codigoTributario === '51' ||
          codigoTributario === '52' ||
          codigoTributario === '53' ||
          codigoTributario === '54' ||
          codigoTributario === '55' ||
          codigoTributario === '99') && (
          <>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id="codigoEnquadramento"
                label="Código de enquadramento"
                value={produto?.fiscal?.ipi?.codigoEnquadramento}
              />
            </Grid>
          </>
        )}

        {(codigoTributario === '50' || codigoTributario === '99') && (
          <>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel id="aliquota" label="Alíquota (%)" value={produto?.fiscal?.ipi?.aliquota} />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel id="valorBc" label="Valor da BC do IPI (R$)" value={valorBcIpi} />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id="tributacaoExclusivaPorUnidade"
                label={
                  <Tooltip title="Produto cuja tributação é exclusiva por unidade" placement="bottom-end">
                    <Typography style={{ fontWeight: 'bold' }} noWrap>
                      Produto cuja tributação é exclusiva por unidade
                    </Typography>
                  </Tooltip>
                }
                value={produto?.fiscal?.ipi?.tributacaoExclusivaPorUnidade === true ? 'Sim' : 'Não'}
              />
            </Grid>
          </>
        )}
      </>
    );
  };

  const DadosFiscaisReformaTributaria = (value) => {
    return (
      <>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="h6">Reforma tributária</Typography>
          <Divider style={{ height: '2px', background: 'silver' }} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="cstSituacaoTributaria"
            label="Código de situação tributária"
            value={
              value?.cstSituacaoTributaria
                ? `${value?.cstSituacaoTributaria?.codigo} - ${value?.cstSituacaoTributaria?.descricao}`
                : ' - '
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="cstClassificacaoTributaria"
            label="Código de classificação tributária"
            value={
              value?.cstClassificacaoTributaria
                ? `${value?.cstClassificacaoTributaria?.codigo} - ${value?.cstClassificacaoTributaria?.descricao}`
                : ' - '
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="valorIbs" label="Alíquota do IBS (%)" value={value?.valorIbs ? value?.valorIbs : ' - '} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="valorCbs" label="Alíquota do CBS (%)" value={value?.valorCbs ? value?.valorCbs : ' - '} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="valorIs" label="Alíquota do IS (%)" value={value?.valorIs ? value?.valorIs : ' - '} />
        </Grid>
      </>
    );
  };

  const visualizarICMS00 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBc"
            label="Modalidade de determinação da BC"
            value={getModalidadeDeterminacaoBc()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBc"
            label="Valor da BC (R$)"
            value={produto?.fiscal?.icms?.valorBC !== undefined && getCurrency(produto?.fiscal?.icms?.valorBC).trim()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImposto"
            label="Alíquota do imposto (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImposto !== undefined && produto?.fiscal?.icms?.aliquotaImposto.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaRelativoFcp"
            label="Alíquota relativo ao FCP (%)"
            value={
              produto?.fiscal?.icms?.aliquotaRelativoFcp !== undefined &&
              produto?.fiscal?.icms?.aliquotaRelativoFcp.toFixed(4)
            }
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS10 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBc"
            label="Modalidade de determinação da BC"
            value={getModalidadeDeterminacaoBc()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBc"
            label="Valor da BC (R$)"
            value={produto?.fiscal?.icms?.valorBC !== undefined && getCurrency(produto?.fiscal?.icms?.valorBC).trim()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImposto"
            label="Alíquota do imposto (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImposto !== undefined && produto?.fiscal?.icms?.aliquotaImposto.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcp"
            label="Valor da BC do FCP (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcp !== undefined && getCurrency(produto?.fiscal?.icms?.valorBcFcp).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaRelativoFcp"
            label="Alíquota relativo ao FCP (%)"
            value={
              produto?.fiscal?.icms?.aliquotaRelativoFcp !== undefined &&
              produto?.fiscal?.icms?.aliquotaRelativoFcp.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBcIcmsST"
            label={
              <Tooltip title="Modalidade de determinação da BC do ICMS ST" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Modalidade de determinação da BC do ICMS ST
                </Typography>
              </Tooltip>
            }
            value={getModalidadeDeterminacaoBcIcmsSt()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBcIcmsSt"
            label="Redução de BC do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.reducaoBcIcmsSt !== undefined && produto?.fiscal?.icms?.reducaoBcIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsSt"
            label="Valor da BC do ICMS ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="mvaIcmsSt"
            label="MVA do ICMS ST (%)"
            value={produto?.fiscal?.icms?.mvaIcmsSt !== undefined && produto?.fiscal?.icms?.mvaIcmsSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImpostoIcmsSt"
            label="Alíquota do imposto do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt !== undefined &&
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoSt"
            label="Valor da BC do FCP retido por ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoSt"
            label="FCP retido por ST (%)"
            value={produto?.fiscal?.icms?.fcpRetidoSt !== undefined && produto?.fiscal?.icms?.fcpRetidoSt.toFixed(4)}
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS20 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBc"
            label="Modalidade de determinação da BC"
            value={getModalidadeDeterminacaoBc()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBC"
            label="Redução de BC (%)"
            value={produto?.fiscal?.icms?.reducaoBC !== undefined && produto?.fiscal?.icms?.reducaoBC.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBc"
            label="Valor da BC (R$)"
            value={produto?.fiscal?.icms?.valorBC !== undefined && getCurrency(produto?.fiscal?.icms?.valorBC).trim()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImposto"
            label="Alíquota do imposto (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImposto !== undefined && produto?.fiscal?.icms?.aliquotaImposto.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcp"
            label="Valor da BC do FCP (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcp !== undefined && getCurrency(produto?.fiscal?.icms?.valorBcFcp).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaRelativoFcp"
            label="Alíquota relativo ao FCP (%)"
            value={
              produto?.fiscal?.icms?.aliquotaRelativoFcp !== undefined &&
              produto?.fiscal?.icms?.aliquotaRelativoFcp.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorDesoneracao"
            label="Valor da desoneração (R$)"
            value={
              produto?.fiscal?.icms?.valorDesoneracao !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorDesoneracao).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="motivoDesoneracao" label="Motivo da desoneração" value={getMotivoDesoneracao()} />
        </Grid>
      </>
    );
  };

  const visualizarICMS30 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBcIcmsST"
            label={
              <Tooltip title="Modalidade de determinação da BC do ICMS ST" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Modalidade de determinação da BC do ICMS ST
                </Typography>
              </Tooltip>
            }
            value={getModalidadeDeterminacaoBcIcmsSt()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBcIcmsSt"
            label="Redução de BC do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.reducaoBcIcmsSt !== undefined && produto?.fiscal?.icms?.reducaoBcIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsSt"
            label="Valor da BC do ICMS ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="mvaIcmsSt"
            label="MVA do ICMS ST (%)"
            value={produto?.fiscal?.icms?.mvaIcmsSt !== undefined && produto?.fiscal?.icms?.mvaIcmsSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImpostoIcmsSt"
            label="Alíquota do imposto do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt !== undefined &&
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoSt"
            label="Valor da BC do FCP retido por ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoSt"
            label="FCP retido por ST (%)"
            value={produto?.fiscal?.icms?.fcpRetidoSt !== undefined && produto?.fiscal?.icms?.fcpRetidoSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorDesoneracao"
            label="Valor da desoneração (R$)"
            value={
              produto?.fiscal?.icms?.valorDesoneracao !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorDesoneracao).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="motivoDesoneracao" label="Motivo da desoneração" value={getMotivoDesoneracao()} />
        </Grid>
      </>
    );
  };

  const visualizarICMS40_41_50 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorDesoneracao"
            label="Valor da desoneração (R$)"
            value={
              produto?.fiscal?.icms?.valorDesoneracao !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorDesoneracao).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="motivoDesoneracao" label="Motivo da desoneração" value={getMotivoDesoneracao()} />
        </Grid>
      </>
    );
  };

  const visualizarICMS51 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBc"
            label="Modalidade de determinação da BC"
            value={getModalidadeDeterminacaoBc()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBC"
            label="Redução de BC (%)"
            value={produto?.fiscal?.icms?.reducaoBC !== undefined && produto?.fiscal?.icms?.reducaoBC.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBc"
            label="Valor da BC (R$)"
            value={produto?.fiscal?.icms?.valorBC !== undefined && getCurrency(produto?.fiscal?.icms?.valorBC).trim()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImposto"
            label="Alíquota do imposto (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImposto !== undefined && produto?.fiscal?.icms?.aliquotaImposto.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorIcmsOperacao"
            label="Valor do ICMS da operação (R$)"
            value={
              produto?.fiscal?.icms?.valorIcmsOperacao !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorIcmsOperacao).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="diferimento"
            label="Diferimento (%)"
            value={produto?.fiscal?.icms?.diferimento !== undefined && produto?.fiscal?.icms?.diferimento.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcp"
            label="Valor da BC do FCP (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcp !== undefined && getCurrency(produto?.fiscal?.icms?.valorBcFcp).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaRelativoFcp"
            label="Alíquota relativo ao FCP (%)"
            value={
              produto?.fiscal?.icms?.aliquotaRelativoFcp !== undefined &&
              produto?.fiscal?.icms?.aliquotaRelativoFcp.toFixed(4)
            }
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS60 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsStRetido"
            label="Valor da BC do ICMS ST retido (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsStRetido !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsStRetido).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaSuportadaConsumidorFinal"
            label={
              <Tooltip title="Alíquota suportada pelo consumidor final (%)" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Alíquota suportada pelo consumidor final (%)
                </Typography>
              </Tooltip>
            }
            value={
              produto?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal !== undefined &&
              produto?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorIcmsStRetido"
            label="Valor do ICMS ST retido (R$)"
            value={
              produto?.fiscal?.icms?.valorIcmsStRetido !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorIcmsStRetido).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorIcmsProprioSubstituto"
            label="Valor do ICMS próprio do substituto (R$)"
            value={
              produto?.fiscal?.icms?.valorIcmsProprioSubstituto !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorIcmsProprioSubstituto).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoAnteriormenteSt"
            label={
              <Tooltip title="Valor da BC do FCP retido anteriormente por ST (R$)" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Valor da BC do FCP retido anteriormente por ST (R$)
                </Typography>
              </Tooltip>
            }
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoAnteriormenteSt"
            label="FCP retido anteriormente por ST (%)"
            value={
              produto?.fiscal?.icms?.fcpRetidoAnteriormenteSt !== undefined &&
              produto?.fiscal?.icms?.fcpRetidoAnteriormenteSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBCEfetiva"
            label="Valor da BC efetiva (R$)"
            value={
              produto?.fiscal?.icms?.valorBCEfetiva !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBCEfetiva).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBCEfetiva"
            label="Redução da BC efetiva (%)"
            value={
              produto?.fiscal?.icms?.reducaoBCEfetiva !== undefined &&
              produto?.fiscal?.icms?.reducaoBCEfetiva.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaIcmsEfetiva"
            label="Alíquota do ICMS efetiva (%)"
            value={
              produto?.fiscal?.icms?.aliquotaIcmsEfetiva !== undefined &&
              produto?.fiscal?.icms?.aliquotaIcmsEfetiva.toFixed(4)
            }
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS70_90 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBc"
            label="Modalidade de determinação da BC"
            value={getModalidadeDeterminacaoBc()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBC"
            label="Redução de BC (%)"
            value={produto?.fiscal?.icms?.reducaoBC !== undefined && produto?.fiscal?.icms?.reducaoBC.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBc"
            label="Valor da BC (R$)"
            value={produto?.fiscal?.icms?.valorBC !== undefined && getCurrency(produto?.fiscal?.icms?.valorBC).trim()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImposto"
            label="Alíquota do imposto (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImposto !== undefined && produto?.fiscal?.icms?.aliquotaImposto.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcp"
            label="Valor da BC do FCP (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcp !== undefined && getCurrency(produto?.fiscal?.icms?.valorBcFcp).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaRelativoFcp"
            label="Alíquota relativo ao FCP (%)"
            value={
              produto?.fiscal?.icms?.aliquotaRelativoFcp !== undefined &&
              produto?.fiscal?.icms?.aliquotaRelativoFcp.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBcIcmsST"
            label={
              <Tooltip title="Modalidade de determinação da BC do ICMS ST" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Modalidade de determinação da BC do ICMS ST
                </Typography>
              </Tooltip>
            }
            value={getModalidadeDeterminacaoBcIcmsSt()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="mvaIcmsSt"
            label="MVA do ICMS ST (%)"
            value={produto?.fiscal?.icms?.mvaIcmsSt !== undefined && produto?.fiscal?.icms?.mvaIcmsSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBcIcmsSt"
            label="Redução de BC do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.reducaoBcIcmsSt !== undefined && produto?.fiscal?.icms?.reducaoBcIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsSt"
            label="Valor da BC do ICMS ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImpostoIcmsSt"
            label="Alíquota do imposto do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt !== undefined &&
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoSt"
            label="Valor da BC do FCP retido por ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoSt"
            label="FCP retido por ST (%)"
            value={produto?.fiscal?.icms?.fcpRetidoSt !== undefined && produto?.fiscal?.icms?.fcpRetidoSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorDesoneracao"
            label="Valor da desoneração (R$)"
            value={
              produto?.fiscal?.icms?.valorDesoneracao !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorDesoneracao).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="motivoDesoneracao" label="Motivo da desoneração" value={getMotivoDesoneracao()} />
        </Grid>
      </>
    );
  };

  const visualizarICMS101 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaAplicavelCalculoCredito"
            label={
              <Tooltip title="Alíquota aplicável de cálculo de crédito (%)" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Alíquota aplicável de cálculo de crédito (%)
                </Typography>
              </Tooltip>
            }
            value={
              produto?.fiscal?.icms?.aliquotaAplicavelCalculoCredito !== undefined &&
              produto?.fiscal?.icms?.aliquotaAplicavelCalculoCredito.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorCreditoIcms"
            label="Valor de crédito do ICMS (R$)"
            value={
              produto?.fiscal?.icms?.valorCreditoIcms !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorCreditoIcms).trim()
            }
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS102_103_300_400 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
      </>
    );
  };

  const visualizarICMS201 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBcIcmsST"
            label={
              <Tooltip title="Modalidade de determinação da BC do ICMS ST" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Modalidade de determinação da BC do ICMS ST
                </Typography>
              </Tooltip>
            }
            value={getModalidadeDeterminacaoBcIcmsSt()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBcIcmsSt"
            label="Redução de BC do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.reducaoBcIcmsSt !== undefined && produto?.fiscal?.icms?.reducaoBcIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsSt"
            label="Valor da BC do ICMS ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="mvaIcmsSt"
            label="MVA do ICMS ST (%)"
            value={produto?.fiscal?.icms?.mvaIcmsSt !== undefined && produto?.fiscal?.icms?.mvaIcmsSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImpostoIcmsSt"
            label="Alíquota do imposto do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt !== undefined &&
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoSt"
            label="Valor da BC do FCP retido por ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoSt"
            label="FCP retido por ST (%)"
            value={produto?.fiscal?.icms?.fcpRetidoSt !== undefined && produto?.fiscal?.icms?.fcpRetidoSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaAplicavelCalculoCredito"
            label={
              <Tooltip title="Alíquota aplicável de cálculo de crédito (%)" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Alíquota aplicável de cálculo de crédito (%)
                </Typography>
              </Tooltip>
            }
            value={
              produto?.fiscal?.icms?.aliquotaAplicavelCalculoCredito !== undefined &&
              produto?.fiscal?.icms?.aliquotaAplicavelCalculoCredito.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorCreditoIcms"
            label="Valor de crédito do ICMS (R$)"
            value={
              produto?.fiscal?.icms?.valorCreditoIcms !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorCreditoIcms).trim()
            }
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS202_203 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBcIcmsST"
            label={
              <Tooltip title="Modalidade de determinação da BC do ICMS ST" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Modalidade de determinação da BC do ICMS ST
                </Typography>
              </Tooltip>
            }
            value={getModalidadeDeterminacaoBcIcmsSt()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBcIcmsSt"
            label="Redução de BC do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.reducaoBcIcmsSt !== undefined && produto?.fiscal?.icms?.reducaoBcIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsSt"
            label="Valor da BC do ICMS ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="mvaIcmsSt"
            label="MVA do ICMS ST (%)"
            value={produto?.fiscal?.icms?.mvaIcmsSt !== undefined && produto?.fiscal?.icms?.mvaIcmsSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImpostoIcmsSt"
            label="Alíquota do imposto do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt !== undefined &&
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoSt"
            label="Valor da BC do FCP retido por ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoSt"
            label="FCP retido por ST (%)"
            value={produto?.fiscal?.icms?.fcpRetidoSt !== undefined && produto?.fiscal?.icms?.fcpRetidoSt.toFixed(4)}
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS500 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsStRetido"
            label="Valor da BC do ICMS ST retido (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsStRetido !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsStRetido).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaSuportadaConsumidorFinal"
            label={
              <Tooltip title="Alíquota suportada pelo consumidor final (%)" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Alíquota suportada pelo consumidor final (%)
                </Typography>
              </Tooltip>
            }
            value={
              produto?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal !== undefined &&
              produto?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorIcmsProprioSubstituto"
            label="Valor do ICMS próprio do substituto (R$)"
            value={
              produto?.fiscal?.icms?.valorIcmsProprioSubstituto !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorIcmsProprioSubstituto).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorIcmsStRetido"
            label="Valor do ICMS ST retido (R$)"
            value={
              produto?.fiscal?.icms?.valorIcmsStRetido !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorIcmsStRetido).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoAnteriormenteSt"
            label={
              <Tooltip title="Valor da BC do FCP retido anteriormente por ST (R$)" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Valor da BC do FCP retido anteriormente por ST (R$)
                </Typography>
              </Tooltip>
            }
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoAnteriormenteSt"
            label="FCP retido anteriormente por ST (%)"
            value={
              produto?.fiscal?.icms?.fcpRetidoAnteriormenteSt !== undefined &&
              produto?.fiscal?.icms?.fcpRetidoAnteriormenteSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBCEfetiva"
            label="Valor da BC efetiva (R$)"
            value={
              produto?.fiscal?.icms?.valorBCEfetiva !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBCEfetiva).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBCEfetiva"
            label="Redução da BC efetiva (%)"
            value={
              produto?.fiscal?.icms?.reducaoBCEfetiva !== undefined &&
              produto?.fiscal?.icms?.reducaoBCEfetiva.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaIcmsEfetiva"
            label="Alíquota do ICMS efetiva (%)"
            value={
              produto?.fiscal?.icms?.aliquotaIcmsEfetiva !== undefined &&
              produto?.fiscal?.icms?.aliquotaIcmsEfetiva.toFixed(4)
            }
          />
        </Grid>
      </>
    );
  };

  const visualizarICMS900 = () => {
    return (
      <>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="situacaoTributaria" label="Situação tributária" value={getSituacaoTributaria()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBc"
            label="Modalidade de determinação da BC"
            value={getModalidadeDeterminacaoBc()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBC"
            label="Redução de BC (%)"
            value={produto?.fiscal?.icms?.reducaoBC !== undefined && produto?.fiscal?.icms?.reducaoBC.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBc"
            label="Valor da BC (R$)"
            value={produto?.fiscal?.icms?.valorBC !== undefined && getCurrency(produto?.fiscal?.icms?.valorBC).trim()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImposto"
            label="Alíquota do imposto (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImposto !== undefined && produto?.fiscal?.icms?.aliquotaImposto.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="modalidadeDeterminacaoBcIcmsST"
            label={
              <Tooltip title="Modalidade de determinação da BC do ICMS ST" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Modalidade de determinação da BC do ICMS ST
                </Typography>
              </Tooltip>
            }
            value={getModalidadeDeterminacaoBcIcmsSt()}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="mvaIcmsSt"
            label="MVA do ICMS ST (%)"
            value={produto?.fiscal?.icms?.mvaIcmsSt !== undefined && produto?.fiscal?.icms?.mvaIcmsSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="reducaoBcIcmsSt"
            label="Redução de BC do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.reducaoBcIcmsSt !== undefined && produto?.fiscal?.icms?.reducaoBcIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcIcmsSt"
            label="Valor da BC do ICMS ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcIcmsSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcIcmsSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaImpostoIcmsSt"
            label="Alíquota do imposto do ICMS ST (%)"
            value={
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt !== undefined &&
              produto?.fiscal?.icms?.aliquotaImpostoIcmsSt.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="bcOperacaoPropria"
            label="BC da operação própria (%)"
            value={
              produto?.fiscal?.icms?.bcOperacaoPropria !== undefined &&
              produto?.fiscal?.icms?.bcOperacaoPropria.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="ufIcmsStDevido" label="UF para qual é devido o ICMS ST" value={getUfIcmsStDevido()} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorBcFcpRetidoSt"
            label="Valor da BC do FCP retido por ST (R$)"
            value={
              produto?.fiscal?.icms?.valorBcFcpRetidoSt !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorBcFcpRetidoSt).trim()
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="fcpRetidoSt"
            label="FCP retido por ST (%)"
            value={produto?.fiscal?.icms?.fcpRetidoSt !== undefined && produto?.fiscal?.icms?.fcpRetidoSt.toFixed(4)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="aliquotaAplicavelCalculoCredito"
            label={
              <Tooltip title="Alíquota aplicável de cálculo de crédito (%)" placement="bottom-end">
                <Typography style={{ fontWeight: 'bold' }} noWrap>
                  Alíquota aplicável de cálculo de crédito (%)
                </Typography>
              </Tooltip>
            }
            value={
              produto?.fiscal?.icms?.aliquotaAplicavelCalculoCredito !== undefined &&
              produto?.fiscal?.icms?.aliquotaAplicavelCalculoCredito.toFixed(4)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="valorCreditoIcms"
            label="Valor de crédito do ICMS (R$)"
            value={
              produto?.fiscal?.icms?.valorCreditoIcms !== undefined &&
              getCurrency(produto?.fiscal?.icms?.valorCreditoIcms).trim()
            }
          />
        </Grid>
      </>
    );
  };

  const Imagens = () => {
    return <Carousel images={produto?.imagens} />;
  };

  const Content = () => {
    const [expanded, setExpanded] = useState('dadosProduto');

    const handleExpandedChange = (key, value) => {
      if (value) {
        setExpanded(key);
      } else {
        setExpanded(false);
      }
    };
    return (
      <div>
        <CustomExpandedPanel
          title="Dados do produto"
          expanded={expanded === 'dadosProduto'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('dadosProduto', value)}
        >
          <DadosProduto />
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Dados fiscais"
          expanded={expanded === 'dadosFiscais'}
          onChange={(_, value) => handleExpandedChange('dadosFiscais', value)}
        >
          <DadosFiscais />
        </CustomExpandedPanel>
        {produto?.imagens?.length && (
          <CustomExpandedPanel
            title="Imagens do produto"
            expanded={expanded === 'imagens'}
            onChange={(_, value) => handleExpandedChange('imagens', value)}
          >
            <Imagens />
          </CustomExpandedPanel>
        )}
      </div>
    );
  };

  return (
    <SimpleDialog open={modal === produtoModais.visualizacaoProduto} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Produto',
          icon: <FaShoppingCart />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
              {permissaoUtils.produto().editar && (
                <EditButton id="add-classe-root" type="submit" onClick={handleOpenEditMode}>
                  Editar
                </EditButton>
              )}
            </>
          ),
        }}
        contentStyle={{ padding: 0 }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarProdutoModal;
